export const avatarStateAttributesMapping = {
  imageLoadingStatus: () => null,
};
